import React, { useState } from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { Modal } from './Modal';
import { hasPermission } from '../api/auth';
import { testerFeedbackApi } from '../api/infra/tester-feedback';
import { useToast } from '../hooks/useToast';

/**
 * Floating «Сообщить об ошибке» for authenticated testers.
 * Reports land in /tester-feedback inbox (feedback.view).
 */
export function TesterFeedbackWidget() {
  const toast = useToast();
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  if (!hasPermission('feedback.create')) return null;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const text = description.trim();
    if (text.length < 3) {
      toast.error('Опишите проблему подробнее');
      return;
    }
    setLoading(true);
    try {
      await testerFeedbackApi.create({
        description: text,
        pageUrl: window.location.href,
      });
      toast.success('Спасибо! Отчёт сохранён');
      setDescription('');
      setOpen(false);
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Не удалось отправить');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="tester-feedback-fab"
        title="Сообщить об ошибке"
        aria-label="Сообщить об ошибке"
        onClick={() => setOpen(true)}
      >
        <MessageSquarePlus size={22} />
        <span className="tester-feedback-fab__label">Баг</span>
      </button>

      {open && (
        <Modal
          title="Сообщить об ошибке"
          onClose={() => !loading && setOpen(false)}
          onSubmit={submit}
          loading={loading}
          submitLabel="Отправить"
          submitDisabled={description.trim().length < 3}
        >
          <p className="tester-feedback-hint">
            Кратко опишите, что не так. Страница и браузер сохранятся автоматически.
          </p>
          <label className="form-label" htmlFor="tester-feedback-desc">
            Описание
          </label>
          <textarea
            id="tester-feedback-desc"
            className="form-input"
            rows={5}
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Например: кнопка «Повторить» не нажимается на /all-orders"
            autoFocus
            maxLength={5000}
          />
          <div className="tester-feedback-meta">
            {window.location.pathname}
          </div>
        </Modal>
      )}
    </>
  );
}
